import React from "react";
import './style.scss';

type Props = {
    onComplete?: () => void
}

type Item = {
    label: string,
    information?: boolean
}

const TaskGame2: React.FunctionComponent<Props> = () => {

    const data : Item[] = [
        {
            label: 'Jarmiła Rybicka i Piotr Matkowski stworzyli w Warszawie oryginalną restaurację Kuchnia Konfliktu, w której zatrudnieni są wyłącznie obcokrajowcy, a dokładnie uchodźcy.',
            information: true
        },
        {
            label: 'Czarne ubrania, parasolki, subtelne elementy ubioru były wyrazem braku zgody na całkowity zakaz aborcji.',
            information: true
        },
        {
            label: 'Inicjatywy oparte na tolerancji i solidarności nigdy nie przechodzą bez echa.'
        },
        {
            label: 'W 1999 roku siostra Gramick otrzymała nawet zakaz wypowiedzi, wydany przez Kongregację Nauki i Wiary.',
            information: true
        },
        {
            label: 'Zabójstwo prezydenta Gdańska Pawła Adamowicza wstrząsnęło wszystkimi Polakami.'
        },
        {
            label: 'Młodzi ludzie udowodnili, że są otwarci i pełni empatii, czym na pewno utarli nosa wielu, konserwatywnym jednostkom.'
        },
        {
            label: 'Jedzenie jest czymś, co może przełamać wszystkie bariery, wprowadzić pokój.'
        },
        {
            label: 'Na manifestacjach pojawiali się politycy różnych ugrupowań politycznych.',
            information: true
        },
        {
            label: 'W Polsce fundacją wspierającą homoseksualnych, biseksualnych i transpłciowych chrześcijan jest Wiara i Tęcza.',
            information: true
        }
        // {
        //     label: '[Czarny Poniedziałek] To lekcja, która wielu czołowych polityków nauczyła pokory.'
        // }
    ]

    return (
        <ul className="task-game-2">
            {
                data.map((i, index) => {
                    return (
                        <li key={index}>
                            <p>{i.label}</p>
                            <div className="buttons">
                                <label className={`${i.information ? 'correct' : 'wrong'}`}>
                                    <input type="radio" name={`r-${index}`} />
                                    <span>INFORMACJA</span>
                                </label>
                                <label className={`${!i.information ? 'correct' : 'wrong'}`}>
                                    <input type="radio" name={`r-${index}`} />
                                    <span>Opinia</span>
                                </label>
                            </div>
                        </li>
                    )
                })
            }
        </ul>
    )
}

export default TaskGame2;
